import { useEffect, useState } from "react";
import Pagination from "../../components/pagination";
import MainLayout from "../../layout";
import { url } from "../../config";
import axios from "axios";
import FilterDrawer from "../../components/filter/filter-drawer";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  TabelArrayText,
  TabelBooleanText,
  TabelImage,
} from "../../components/view-form-components/tabel-cell-view";
import { types, uiTypes } from "../../utils/types";
import DeleteModal from "../../components/modal/delete-modal";
import Loader from "../../assets/icons/loader/loader";
import queryString from "query-string";
import { formatUnderscoreToSpace } from "../../utils/text-format";
import ExportModal from "../../components/modal/export-modal";

const ListPage = ({ model }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);

  const { tableName, columns, read, edit, create, references } = model;
  const [data, setData] = useState({
    rows: [],
    page: 1,
    count: 0,
  });
  const [loading, setLoading] = useState(true);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [exportModalShow, setExportModalShow] = useState(false);
  const [selectDelete, setSelectDelete] = useState("");

  const columnHeadings = () => {
    var array = [];
    for (var i = 0; i < columns.length; i++) {
      var column = columns[i];
      if (column.ui?.list == null || column.ui.list == true) {
        array.push(column.name);
      }
    }
    return array;
  };

  const headings = columnHeadings();

  function normalizeParsedParams(parsed) {
    const result = {};

    for (const [key, value] of Object.entries(parsed)) {
      const match = key.match(/^(\w+)\[(\w+)\]$/);
      if (match) {
        const [, parent, child] = match;
        if (!result[parent]) result[parent] = {};
        result[parent][child] = value;
      } else {
        result[key] = value;
      }
    }

    return result;
  }

  const fetchData = () => {
    const rawFilters = queryString.parse(location.search, {
      arrayFormat: "bracket",
    });

    const filters = normalizeParsedParams(rawFilters);

    setLoading(true);
    axios
      .post(`${url}/model/${tableName}/list`, {
        page: page_no,
        ...filters,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        if (res.data.data.rows.length === 0 && page_no > 1) {
          navigate(
            `/${tableName}/list?page=${page_no - 1}${
              filters ? `&${filters}` : ""
            }`,
            { replace: true },
          );
          return;
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [tableName, page_no, location.search]);

  const searchParams = new URLSearchParams(location.search);
  searchParams.delete("page");
  const filters = searchParams.toString() ? `&${searchParams.toString()}` : "";

  const deleteFnc = (id) => {
    axios
      .post(`${url}/model/${tableName}/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  return (
    <MainLayout>
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
          setSelectDelete("");
        }}
        btnFnc={() => deleteFnc(selectDelete)}
      />
      <ExportModal
        isOpen={exportModalShow}
        onClose={() => {
          setExportModalShow(false);
        }}
        tableName={tableName}
        columns={columns}
      />
      <section className="h-full">
        <div className="flex justify-between items-center mb-5">
          <h2 className="text-xl font-semibold capitalize">
            {formatUnderscoreToSpace(tableName)} List
          </h2>
          <div className="flex gap-2 relative">
            <FilterDrawer
              open={filterDrawerOpen}
              onClose={() => setFilterDrawerOpen(false)}
              columns={columns}
              references={references}
              queryParamsData={queryParamsData}
            />
            <button
              onClick={() => setExportModalShow(true)}
              type="button"
              className="px-4 py-2 bg-gray-500 text-white rounded"
            >
              Export
            </button>
            <Link
              className="px-4 py-2 bg-primary text-white rounded"
              to={`/${tableName}/create`}
            >
              Create
            </Link>
            <button
              onClick={() => setFilterDrawerOpen(true)}
              className="px-4 py-1 bg-secondary text-white rounded"
            >
              Filters
            </button>
          </div>
        </div>
        <section className="h-[calc(100%-3.5rem)] flex flex-col justify-between overflow-auto">
          <div className="w-full max-w-[82.2vw]  overflow-auto h-full">
            <table className="w-full table-auto border border-gray-200 text-nowrap overflow-auto relative">
              <thead>
                <tr className="bg-gray-100">
                  <th className="p-1 bg-gray-100">#</th>
                  {headings.map((value, index) => {
                    return (
                      <th
                        key={index}
                        className="px-4 py-2 text-left capitalize text-fs_16 font-fw_600"
                      >
                        {formatUnderscoreToSpace(value)}
                      </th>
                    );
                  })}
                  <th className="px-4 py-2 text-left sticky right-0 z-10 bg-gray-100">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="overflow-auto">
                {loading ? (
                  <tr>
                    <td rowSpan={1} colSpan={headings?.length + 1}>
                      <div className="w-full flex justify-center py-5">
                        <div className="h-[100px] w-[100px]">
                          <Loader />
                        </div>
                      </div>
                    </td>
                  </tr>
                ) : (
                  <>
                    {data.rows?.length ? (
                      <>
                        {data.rows.map((row, index) => {
                          return (
                            <tr key={index} className="border-t bg-white">
                              <td className="p-1 px-2">
                                {(data?.page - 1) * 10 + (index + 1)}
                              </td>
                              {headings.map((heading) => {
                                var column = columns.find(
                                  (value) => value.name == heading,
                                );
                                if (column.isArray) {
                                  return (
                                    <td className="px-4 py-2">
                                      <TabelArrayText
                                        arrayData={row[heading]}
                                      />
                                    </td>
                                  );
                                }
                                if (column.type == types.BOOLEAN) {
                                  return (
                                    <td className="px-4 py-2">
                                      <TabelBooleanText value={row[heading]} />
                                    </td>
                                  );
                                }
                                if (column?.ui?.type == uiTypes.IMAGE) {
                                  return (
                                    <td className="px-4 py-2">
                                      <TabelImage url={row[heading]} />
                                    </td>
                                  );
                                }
                                if (column?.ui?.type == uiTypes.DOCUMENT_ALT) {
                                  return (
                                    <td className="px-4 py-2">
                                      <TabelImage url={row[heading]?.url} />
                                    </td>
                                  );
                                }
                                return (
                                  <td className="px-4 py-2 max-w-[350px]">
                                    <span className="truncate overflow-hidden whitespace-nowrap block">
                                      {row[heading] ?? "--"}
                                    </span>
                                  </td>
                                );
                              })}

                              <td className="py-2 sticky right-0 z-10">
                                <div className="flex gap-3 bg-white px-4">
                                  <Link
                                    to={`/${tableName}/view/${row["id"]}`}
                                    className="text-secondary border-[1px] border-secondary px-3 py-1 rounded-md text-fs_14 hover:bg-green-50"
                                  >
                                    View
                                  </Link>
                                  <Link
                                    to={`/${tableName}/edit/${row["id"]}`}
                                    className="text-primary border-[1px] border-primary px-3 py-1 rounded-md text-fs_14 hover:bg-blue-50"
                                  >
                                    Edit
                                  </Link>
                                  <button
                                    onClick={() => {
                                      setdeleteModalShow(true);
                                      setSelectDelete(row["id"]);
                                    }}
                                    className="text-errorColor border-[1px] border-errorColor px-3 py-1 rounded-md text-fs_14 hover:bg-red-50"
                                  >
                                    Delete
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </>
                    ) : (
                      <tr>
                        <td colSpan={headings?.length + 1}>
                          <p className="text-center my-5">No data found</p>
                        </td>
                      </tr>
                    )}
                  </>
                )}
              </tbody>
            </table>
          </div>
          <div
            className={`${
              loading === true ? "pointer-events-none opacity-45" : ""
            }`}
          >
            <Pagination
              totalPages={parseInt(data?.count) ?? 0}
              pagination={parseInt(data?.page) ?? 0}
              path={`/${tableName}/list`}
              filters={filters}
            />
          </div>
        </section>
      </section>
    </MainLayout>
  );
};

export default ListPage;
